// extracted by mini-css-extract-plugin
export default {"root":"HeaderText_root__FlAkz"};